export default {
    licencedUsers: {
        ADMIN: 'Admin',
        STANDARD: 'Standard'
    },
    licencedReaders: {
        AUTHORIZED_READER: 'Authorized Reader',
        NEWSDESK_DIRECT: 'Newsdesk Direct'
    },
    mobileApp: {
        MOBILE_APP: 'Mobile App'
    },
    unassigned: {
        UNASSIGNED: 'Unassigned'
    }
};

export const USER_TYPES = {
    ADMIN: 'ADMIN',
    STANDARD: 'STANDARD',
    AUTHORIZED_READER: 'AUTHORIZED_READER',
    NEWSDESK_DIRECT: 'NEWSDESK_DIRECT',
    MOBILE_APP: 'MOBILE_APP'
};
